import React from "react";
import {
    FormControl,
    Grid,
    IconButton,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import NextPlanIcon from "@mui/icons-material/NextPlan";
import stylesConfig from "../../theme/config";

interface Ioption {
    [key: string]: any;
}

export type DropDownSelectionHandleType = {
    getDropDownSelectItem: () => void;
};
const getEntries = (obj: Ioption) => Object.entries(obj) as [string, any][];

const DropDown: React.FC<any> = ({
                                     isDisabled,
                                     index,
                                     row,
                                     handleSelectionChange,
                                     handleDropdownCopy,
    isLastItem
  }
  ) => {

    const defaultOption = {1: 'No relevant products to match'}
    const showValue = () => {
        if (row.status === 1) {
            return String(row.matchedProduct.id);
        }
        if (!row.userSelectedItem) {
            return '0';
        }
        if (!row.userSelectedItem.productId) {
            return '1';
        }
        return String(row.userSelectedItem.productId);
    };

    /*React.useEffect(()=>{//copy hot word from above row
        console.log("please do someting");

        showValue();
    },[row])*/

    const selectionChange=(e: SelectChangeEvent)=>{
        const {value} = e.target;
      if(value === '0')return;
        const currentRow = row.multiMatched[value];
      const selectedInfo = (value === '1') ? defaultOption[1] : `${currentRow.vendor} >> ${currentRow.name}`
      handleSelectionChange({
              'productId': currentRow?.id,
                productName: currentRow?.name,
              'label': selectedInfo,
                vendorName: currentRow?.vendor,
                vendorId: currentRow?.vendorId,
              description: currentRow?.description?.replace(/<\/?[^>]+(>|$)/g, "") ?? defaultOption[1],
      }, row.row)
    }

    let dropdown = null;
    if (row.status === 1) {
        dropdown = (
            <p>{`${row.matchedProduct.vendor} >> ${row.matchedProduct.name}`}</p>
        );
    } else if (row.status === 2) {

        // const entries = Object.entries( row.multiMatched) as Entries<Ioption>;
        //console.log(row.multiMatched);
        const items = getEntries(row.multiMatched)
            .map(([id, info]) => ({
                id,
                label: info.vendor + " >> " + info.name,
            }))
            .sort((a, b) => a.label.localeCompare(b.label));

        dropdown = (
            <FormControl sx={{ m: 1, minWidth: 360 }}>
                <Select
                    id={`dd_${index}`}
                    disabled={isDisabled}
                    value={showValue()}
                    onChange={selectionChange}
                    inputProps={{ "aria-label": "controlled" }}
                >
                    <MenuItem value="0">
                        <em>Please select a product</em>
                    </MenuItem>
                    <MenuItem value="1">{defaultOption[1]}</MenuItem>
                    {items.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                            {item.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    } else {
        dropdown = <p>No Item</p>;
    }

    return (
        <Grid container alignItems="center" spacing={1} wrap="nowrap">
            <Grid item>{dropdown}</Grid>
            {!isLastItem && (
                <Grid item>
                    <IconButton
                        aria-label="copy to next row"
                        onClick={() => handleDropdownCopy(showValue(), index)}
                        sx={{ color: stylesConfig.tiles.govTile }}
                    >
                        <NextPlanIcon fontSize="small" />
                    </IconButton>
                </Grid>
            )}
        </Grid>
    );
};

export default DropDown;
